import type { HeaderUser, HomeData } from '../types/frontV2';

export const FRONT_CURRENT_USER_CACHE_KEY = 'front-v2-current-user';
export const FRONT_HOME_DATA_CACHE_KEY = 'front-v2-home-data';

export function readCachedHomeData() {
  if (typeof window === 'undefined') return null;
  try {
    const cachedUser = readCachedHeaderUser();
    if (!cachedUser?.id) return null;
    const cached = window.sessionStorage.getItem(FRONT_HOME_DATA_CACHE_KEY);
    if (!cached) return null;
    const parsed = JSON.parse(cached);
    if (!parsed?.user?.id || parsed.user.id !== cachedUser.id) return null;
    return parsed as HomeData;
  } catch (e) {
    return null;
  }
}

export function writeCachedHomeData(data: HomeData) {
  if (typeof window === 'undefined' || !data.user?.id) return;
  try {
    window.sessionStorage.setItem(FRONT_HOME_DATA_CACHE_KEY, JSON.stringify(data));
  } catch (e) {
    // The cache only smooths refresh transitions; API data remains authoritative.
  }
}

export function readCachedHeaderUser(): HeaderUser | null {
  if (typeof window === 'undefined') return null;
  try {
    const cached = window.sessionStorage.getItem(FRONT_CURRENT_USER_CACHE_KEY);
    return cached ? JSON.parse(cached) : null;
  } catch (e) {
    return null;
  }
}

export function clearFrontSessionCaches() {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.removeItem(FRONT_CURRENT_USER_CACHE_KEY);
    window.sessionStorage.removeItem(FRONT_HOME_DATA_CACHE_KEY);
  } catch (e) {
    // Session cache is best-effort.
  }
}
